import React, { Component, PropsWithChildren } from 'react'

export type PropsProviderContext = {
  isChatWindowVisible?: boolean
  hideKnowledgeContent?: boolean
}

const PropsContext = React.createContext<PropsProviderContext | null>(null)

class PropsProvider extends Component<PropsWithChildren<PropsProviderContext>> {
  render() {
    const { children, ...props } = this.props
    return (
      <PropsContext.Provider value={props}>{children}</PropsContext.Provider>
    )
  }
}

export { PropsProvider }
export default PropsContext
